import $ from '../_snowpack/pkg/jquery.js';
import L from '../_snowpack/pkg/leaflet.js';
import { Capacitor } from '../_snowpack/pkg/@capacitor/core.js';
import '../_snowpack/pkg/leaflet-extra-markers.js';
import Neignborhood from'./neighborhood.js';
import Navigation from'./navigation.js';
import Location from './location.js';
import Bookmark from './bookmark.js';
import Utils from './utils.js';
import Video from'./video.js';
import Auth from'./auth.js';
import Users from './users.js';
let params, param, caram, map, markerGroup, master_spots, polygon, _menu;
const isNative = Capacitor.isNative;
const ROOT = isNative ? 'https://hipster.io' : '';
const city = Utils.getType();

(async () => {
	window.calendar = [];
	const { menu, submenu  } = await firstTitle();
  _menu=menu;
  window.submenu = submenu;
  const [town] = await fetch(`https://hipster.io/api/town?filter=url||$eq||${city}`).then(response => response.json());
  window.glb=town.latlng;
  map = L.map('map', {
    center: town.latlng ?? [38.91484, -77.036497],
    layers: [
      L.tileLayer('https://stamen-tiles-{s}.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.png'),
      L.tileLayer('https://stamen-tiles-{s}.a.ssl.fastly.net/toner-labels/{z}/{x}/{y}.png')
    ],
    maxZoom: 18,
    minZoom: 13,
    zoom: 14,
    attributionControl: false
  });
  window.map = map;
  markerGroup = L.layerGroup().addTo(map);

  setTimeout(() => map.invalidateSize(), 1500);

	params = new URLSearchParams(window.location.search);
	param = params.get('g');
  //setTimeout(() => $('.calendars').click(), 1500);

  //if(param==undefined || param=='null' || param==null){//category logic
  //	setTimeout(() => $('#open').click(), 1500);
  //}

  setTimeout(() => adate(), 2500);
  //setTimeout(() => $('.filters-content aside span').first().click(), 3000);

	setTimeout(async function() {
		params = new URLSearchParams(window.location.search);
  	param = params.get('g');
  	$('.rightrail .col').each(function() {
  		if( $(this).attr('data-category')==param ) {
  			$(this).find('img').css('background','rgba(255, 97, 253,.5)').css('border-radius','100px');
  		}
  	});

	}, 1500);

	/*setTimeout(function() {
  	var counter=0;
  	$('.filters-content aside').each(function() {
  		counter++;
  	});
  	alert(counter);
	}, 10000);*/

	var theRandomNumber = Math.floor(Math.random() * 10) + 1;
  master_spots = await fetch(`${ROOT}/json/${city}_gen.json?v=${theRandomNumber}`).then(response => response.json());
  updateMarkers(master_spots.filter(spot => spot.groups && spot.groups[param]));
  window.spots = master_spots;
  window.title='ish'


  $('.crown').on('click', function() {
    if( $('.bt-crown').hasClass('turnPink') ){
    	$('.searchbox').val('').keyup();
    	$('.searchbox').css('background','white').css('color','#a7a9ac');
    	$('.crown').css('border','4px solid #4bbdfe');
    	$('.bt-crown').removeClass('turnPink');
    } else {
    	$('.searchbox').val('top pick').keyup();
    	$('.searchbox').css('background','#ff61fd').css('color','black');
    	$('.crown').css('border','4px solid #ff61fd');
    	$('.bt-crown').addClass('turnPink');
    }
  });

  function removeCrown(){
    if( $('.bt-crown').hasClass('turnPink') ){
    	$('.crown').css('border','4px solid #4bbdfe');
    	$('.bt-crown').removeClass('turnPink');
    	$('.searchbox').val('').keyup();
    	$('.searchbox').css('background','white').css('color','#a7a9ac');
    }
  }


  $('.openlabel').on('click', function() {
  	removeCrown();
    $('.close-spot').click();
    window.thatOpen = $('#open').is(':checked');
    //alert(thatOpen);
    if(thatOpen==true){
    	$('.openlabel').css('color','#ffffff');
    } else{
    	//$('.openlabel').css('color','#4bbdfe');
    	$('.openlabel').css('color','#ff61fd');
    }
  });

  $('.desc').on('click', '.bt-play-circle', function() {
    Video.open($(this).data('id'));
  });

  $('.navigation').on('keyup', '.searchbox', function() {
  	$('.searchbox').css('background','white');
    $('.crown').css('border','4px solid #4bbdfe');
    $('.bt-crown').removeClass('turnPink');
    var valor=$(this).val().toLowerCase();
		$('.filters-content aside').css('display','block');
  	$('.filters-content aside').each(function() {
  		var temple=$(this).text().toLowerCase();
  		if(temple.includes(valor)){
  			$(this).css('display','block');
  		} else{
  			$(this).css('display','none');
  		}
  	});
  });

  $(document).on('click', '.calendars, .bookmark', function() {
    removeCrown();
    $('.crown').hide();
  });

  $(document).on('click', '.bt-ulist', function() {
    removeCrown();
    $('.crown').show();
  });

  $(document).on('click', '.bt-ulist, .calendars, .neighborhoods', function() {
    $('.statusSelect').hide();
  });

  $(document).on('click', '.bookmark', function() {
    //$('.statusSelect').fadeIn();
    if($('.collapsible i').hasClass('bt-plus-square')){
      $('.statusSelect').hide();
    } else{
      $('.statusSelect').show();
    }
  });


  /*$(document).on('click', '.temppp', async function() {
    await Bookmark.getSaved(Auth.uid,'wantNorush');
    Users.init(Auth.uid, true);
  });*/

  $(document).on('change','.statusSelect', async function(){
    if( $(this).val()=='allFavorites' ){
    	$('.statusSelect').css('background','#ff61fd');
    	await Bookmark.getSaved(Auth.uid);
    	Users.init(Auth.uid, true);
    } else if( $(this).val()=='wantAsap' ){
    	$('.statusSelect').css('background','#32df46');
    	await Bookmark.getSaved(Auth.uid,'wantAsap');
    	Users.init(Auth.uid, true);
    } else if( $(this).val()=='wantNorush' ){
    	$('.statusSelect').css('background','#9760fe');
    	await Bookmark.getSaved(Auth.uid,'wantNorush');
    	Users.init(Auth.uid, true);
    } else if( $(this).val()=='beenDontlike' ){
    	$('.statusSelect').css('background','#ff9232');
    	await Bookmark.getSaved(Auth.uid,'beenDontlike');
    	Users.init(Auth.uid, true);
    } else if( $(this).val()=='beenAndlike' ){
    	$('.statusSelect').css('background','#4bbdfe');
    	await Bookmark.getSaved(Auth.uid,'beenAndlike');
    	Users.init(Auth.uid, true);
    }
  });

  $('.calendars').on('click', function() {
    calendarMarkers();
  });

  $('.desc').on('click', '.bt-heart', async function()  {
  	if (!Auth.isLoggedIn){
  		$('.close-spot').click();
  		return Auth.open();
  	}
  	$('.heartModal').css('display','flex');
  	window.thiss=$(this);
  	window.tempVar=$(this).data('id');
  	$('.wantAsap, .wantNorush, .notInterested, .beenDontlike, .beenAndlike').attr('data-id', $(this).data('id') );
  });

  $(document).on('click', '.heartModal .bt-times-circle', function()  {
  	$('.heartModal').hide();
  });

  $('.heartModal').on('click', '.wantAsap', async function()  {
  	$('.statusSelect').val('allFavorites').change();
		setTimeout(function() {
			$('.heartModal .notInterested').show();
		}, 500);
  	$('.heartModal li').removeClass('onnit');
  	$('.heartModal .wantAsap').addClass('onnit');
  	thiss.removeClass('wantNorush notInterested beenDontlike beenAndlike');
  	thiss.addClass('wantAsap');
    await Bookmark.save(tempVar, Auth.uid, 'wantAsap');
    await Bookmark.getSaved(Auth.uid);
    const bookmarkClass = Bookmark.bookmarks.filter(b => b.place_id === tempVar).length > 0 ? 'btr' : 'btl';
		thiss.removeClass('btl btr').addClass(bookmarkClass);
  	Users.init(Auth.uid, true);
  	$('.heartModal').fadeOut();
  });

  $('.heartModal').on('click', '.wantNorush', async function()  {
  	$('.statusSelect').val('allFavorites').change();
		setTimeout(function() {
			$('.heartModal .notInterested').show();
		}, 500);
  	$('.heartModal li').removeClass('onnit');
  	$('.heartModal .wantNorush').addClass('onnit');
  	thiss.removeClass('wantAsap notInterested beenDontlike beenAndlike');
  	thiss.addClass('wantNorush');
    await Bookmark.save(tempVar, Auth.uid, 'wantNorush');
    await Bookmark.getSaved(Auth.uid);
    const bookmarkClass = Bookmark.bookmarks.filter(b => b.place_id === tempVar).length > 0 ? 'btr' : 'btl';
		thiss.removeClass('btl btr').addClass(bookmarkClass);
  	Users.init(Auth.uid, true);
  	$('.heartModal').fadeOut();
  });

  $('.heartModal').on('click', '.notInterested', async function()  {
  	$('.statusSelect').val('allFavorites').change();
		setTimeout(function() {
			$('.heartModal .notInterested').hide();
		}, 500);
  	$('.heartModal li').removeClass('onnit');
  	thiss.removeClass('wantAsap wantNorush beenDontlike beenAndlike');
  	thiss.addClass('notInterested');
    await Bookmark.save(tempVar, Auth.uid, 'notInterested');
    await Bookmark.getSaved(Auth.uid);
    const bookmarkClass = Bookmark.bookmarks.filter(b => b.place_id === tempVar).length > 0 ? 'btr' : 'btl';
		thiss.removeClass('btl btr').addClass(bookmarkClass);
  	Users.init(Auth.uid, true);
  	$('.heartModal').fadeOut();
  });

  $('.heartModal').on('click', '.beenDontlike', async function()  {
  	$('.statusSelect').val('allFavorites').change();
		setTimeout(function() {
			$('.heartModal .notInterested').show();
		}, 500);
  	$('.heartModal li').removeClass('onnit');
  	$('.heartModal .beenDontlike').addClass('onnit');
  	thiss.removeClass('wantAsap wantNorush notInterested beenAndlike');
    thiss.addClass('beenDontlike');
    await Bookmark.save(tempVar, Auth.uid, 'beenDontlike');
    await Bookmark.getSaved(Auth.uid);
    const bookmarkClass = Bookmark.bookmarks.filter(b => b.place_id === tempVar).length > 0 ? 'btr' : 'btl';
		thiss.removeClass('btl btr').addClass(bookmarkClass);
  	Users.init(Auth.uid, true);
  	$('.heartModal').fadeOut();
  });

  $('.heartModal').on('click', '.beenAndlike', async function()  {
  	$('.statusSelect').val('allFavorites').change();
		setTimeout(function() {
			$('.heartModal .notInterested').show();
		}, 500);
  	$('.heartModal li').removeClass('onnit');
  	$('.heartModal .beenAndlike').addClass('onnit');
  	thiss.removeClass('wantAsap wantNorush notInterested beenDontlike');
  	thiss.addClass('beenAndlike');
    if (!Auth.isLoggedIn) return Auth.open();
    await Bookmark.save(tempVar, Auth.uid, 'beenAndlike');
    await Bookmark.getSaved(Auth.uid);
    const bookmarkClass = Bookmark.bookmarks.filter(b => b.place_id === tempVar).length > 0 ? 'btr' : 'btl';
		thiss.removeClass('btl btr').addClass(bookmarkClass);
  	Users.init(Auth.uid, true);
  	$('.heartModal').fadeOut();
  });

  $('.navigation').on('click', '.navtitle', function() {
  	location.href='../';
  	/*$('.close-spot').click();
  	$('.filters-content aside span').removeClass('activity');
  	$('.filters-content aside section article').removeClass('activity1');

  	$(`.filters-content .${id}`).addClass('activity').get(0).scrollIntoView({ behavior: 'smooth', block: 'center' });
  	$(`.filters-content .${id}`).next().find('article').addClass('activity1');

  	$('.filters-content aside').css('background','black');

  	const isOpen = $('#open').is(':checked');
  	$('.blocker').css('display','flex');
  	if(param==null||param=='null'||param==undefined){
  		location.href='../';
  	} else{
			params.set('g', null);
    	params.set('c', caram);
	    const url = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${params.toString()}`;
	    window.history.pushState({ path: url }, '', url);
			if($('.bt-calendar').hasClass('active')) {
	      setTimeout(() => $('.calendars').click(), 1500);
	  	} else if($('.bt-ulist').hasClass('active')) {
	  		if(isOpen==true){
	  			$('.openlabel').css('color','#ffffff');
	  			setTimeout(() => $('#open').click(), 1500);
	  		}
	  	}

  	}*/
  });

  $('.rightrail').on('click', '.col', function() {//sets the filter on the screen
  	removeCrown();
    window.thatOpen = $('#open').is(':checked');

    $('.openlabel').css('color','#ffffff');

    $('.close-spot').click();
    const category = $(this).data('category');
    params.set('g', category);
    params.set('c', caram);

    //checkOpen();

    const url = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${params.toString()}`;
    window.history.pushState({ path: url }, '', url);
    $('.filters-content input[type="checkbox"]').each(function() { $(this).prop('checked', false ); });
  	$('.filters-content aside').first().click()
  	if($('.bt-calendar').hasClass('active')) {
  		calendarMarkers();
  	}

  	$('.col').find('img').css('background','none');
  	$(this).find('img').css('background','rgba(255, 97, 253,.5)').css('border-radius','100px');
  });

  $('.desc').on('click', '.close-spot', function() {
  	$('.statusSelect').hide();
		$('.filters-content aside span').removeClass('activity');
		$('.filters-content aside section article').removeClass('activity1');

		$('.calendars-content aside span').removeClass('activity');
		$('.calendars-content aside section article').removeClass('activity');

		$('.calendars-content aside').css('background','black');
		$('.filters-content aside').css('background','black');

    if ($('.desc').hasClass('hidden')) return;
    $('.desc').animate({"margin-left": `-=${$('.desc').outerWidth() + 8}`}).addClass('hidden');
    $('.marker-container.active').removeClass('active');
  });

  $('.desc').on('click', '.descneigh', async function() {
    const response = await Neignborhood.getByName($('.descneigh').text());
    if (!response) return;
    if (polygon) polygon.remove();
    polygon = L.polygon(response.points, {
      color: response.lineColor,
      fillColor: response.fillColor,
      fillOpacity: 0.6,
    }).addTo(map);
    map.fitBounds(polygon.getBounds());
  });

  $('.desc').on('click', '.time', function() {
    const id = $(this).data('id');
    const spot = master_spots.find(spot => spot.place_id === id);
    let hours = spot.hours.weekday_text;
    $('.time-modal ul').html('');
    hours = hours.map(hour => {
      const [ day, h ] = hour.split(': ');
      if (h.includes('Closed')) {
        return`${day.substr(0, 3)}: ${h}`;
      } else {
        const [ start, end ] = h.split(' – ');
        return`${day.substr(0, 3)}: ${pad(start)} - ${pad(end)}`;
      }
    });

    function pad(time){
      const [hour, min] = time.split(':');
      if(hour<10){
      	return `0${hour}:${min}`;
      } else{
      	return `${hour}:${min}`;
      }
    }
    hours.map(hour => $('.time-modal ul').append($('<li>').text(hour)));
    $('.time-modal-container').fadeIn()
  });

  $('.time-modal-container').on('click', '.close-times, .time-backdrop', ()=> $('.time-modal-container').fadeOut());

  $('.neighborhoods').on('click', () => {
  	$('.close-spot').click();
    if (Bookmark.isOpen) Bookmark.close();
    Neignborhood.open((response) => {
      if (!response) return;
      if (polygon) polygon.remove();
      polygon = L.polygon(response.points, {
        color: response.lineColor,
        fillColor: response.fillColor,
        fillOpacity: 0.6,
      }).addTo(map);
      map.fitBounds(polygon.getBounds());
    });
  });

  window.addEventListener('locationchange', () => {
  	params = new URLSearchParams(window.location.search);
  	param = params.get('g');
  	caram = params.get('c');
	  if(param==undefined || param=='null' || param==null){//category logic
	    	firstTitle({ menu, submenu });
	    	updateMarkers(master_spots.filter(spot => spot.groups[param]));
	  } else{
	    	setTitle({ menu, submenu });
	    	updateMarkers(master_spots.filter(spot => spot.groups[param]));
	  }
  });

  $('.bookmark').on('click', () => Auth.isLoggedIn ?  null :  Auth.open());
  $('.google').on('click', () => Auth.google());
  $('.apple').on('click', () => Auth.apple());
  $('.close-auth').on('click', () => Auth.close())
  $('.close-video').on('click', () => Video.close());
  $('.close-neighborhood').on('click', () => Neignborhood.close());

  Location.init();
  Navigation.init(menu, submenu);
  checkForMobile();
})();

String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
}

$('.radioshowing').on('click', async() => {
	await fetch('https://hipster.io/api/user-settings', {
	  method: 'POST',
	  body: new URLSearchParams({ uid: Auth.uid, userShow: 1})
	});
});

$('.radionotshowing').on('click', async() => {
	await fetch('https://hipster.io/api/user-settings', {
	  method: 'POST',
	  body: new URLSearchParams({ uid: Auth.uid, userShow: 0})
	});
});

/*
await fetch('https://hipster.io/api/user-settings', {
  method: 'POST',
  body: new URLSearchParams({ uid: Auth.uid, userShow: 1, userMapChoice: 2 })
});
*/

async function firstTitle(response) {
	$('.rightrail').html('');
  if (!response) response = await fetch(`${ROOT}/json/menu.json`).then(response => response.json());
  params = new URLSearchParams(window.location.search);
  param = params.get('g');
  caram = params.get('c');
  //setTimeout(function(){ $('.tab').html(caram).fadeIn(); }, 1400);

  var temp=0;
  var addd='';
  var alll='';
  if(param==undefined || param=='null' || param==null){//categories with no group
  	const isNative = Capacitor.isNative;
  	const ROOT = isNative ? 'https://hipster.io' : '';
	  const response = await fetch(`${ROOT}/json/menu.json`).then(response => response.json());
	  const cat = response.menu.find((o) => o.cat === caram);

	  /*if (cat) {
	    Object.keys(cat.subs).forEach(sub => {
	      const text = response.submenu[sub];
	      const root = isNative ? '/index.html' : '';
	    	$('.rightrail').append($(`<a data-category='${sub}' class='col'>`).html(
	      	`<img src="/fin/groups/${sub}.png" title="${text.name}" />`
	    	));
	    });
	    $('.rightrail').slideDown();
	  } else {
	    window.location.href = '/';
	  }*/

	  window.location.href = '/';

  	if(caram=='bar'){temp=0;addd='s';alll='All ';setTimeout(function(){ $('#bar').trigger('click'); /*$('.bt-search').click();*/ }, 1000); }
  	else if(caram=='breakfast'){temp=1;addd=' Spots';setTimeout(function(){ $('#breakfast').trigger('click'); /*$('.bt-search').click();*/}, 1000);}
  	else if(caram=='restaurant'){temp=2;addd='s';alll='All ';setTimeout(function(){ $('#restaurant').trigger('click'); /*$('.bt-search').click();*/}, 1000);}
  	else if(caram=='lunch'){temp=3;addd=' Spots';setTimeout(function(){ $('#lunch').trigger('click'); /*$('.bt-search').click();*/}, 1000);}
  	else if(caram=='cafe'){temp=4;addd='s';alll='All ';setTimeout(function(){ $('#cafe').trigger('click'); /*$('.bt-search').click();*/}, 1000);}
  	else if(caram=='brunch'){temp=5;addd=' Spots';setTimeout(function(){ $('#brunch').trigger('click'); /*$('.bt-search').click();*/}, 1000);}
  	else if(caram=='club'){temp=6;addd='s';alll='All ';setTimeout(function(){ $('#club').trigger('click'); /*$('.bt-search').click();*/}, 1000);}
  	else if(caram=='dinner'){temp=7;addd=' Spots';setTimeout(function(){ $('#dinner').trigger('click'); /*$('.bt-search').click();*/}, 1000);}
  	else if(caram=='store'){temp=8;addd='s';alll='All ';setTimeout(function(){ $('#store').trigger('click'); /*$('.bt-search').click();*/}, 1000);}
  	else if(caram=='latenight'){temp=9;addd=' Spots';setTimeout(function(){ $('#latenight').trigger('click'); /*$('.bt-search').click();*/}, 1000);}
  	else if(caram=='quiet'){temp=9;addd=' Spots';setTimeout(function(){ $('#quiet').trigger('click'); /*$('.bt-search').click();*/}, 1000);}
  	else if(caram=='divey'){temp=9;addd=' Spots';setTimeout(function(){ $('#divey').trigger('click'); /*$('.bt-search').click();*/}, 1000);}
  	else if(caram=='casual'){temp=9;addd=' Spots';setTimeout(function(){ $('#casual').trigger('click'); /*$('.bt-search').click();*/}, 1000);}
  	else if(caram=='lively'){temp=9;addd=' Spots';setTimeout(function(){ $('#lively').trigger('click'); /*$('.bt-search').click();*/}, 1000);}
  	else if(caram=='intimate'){temp=9;addd=' Spots';setTimeout(function(){ $('#intimate').trigger('click'); /*$('.bt-search').click();*/}, 1000);}

  	const title = response.menu[temp];
 	  $('.navtitle').toggle(title !== undefined);

  	if (title) $('.navtitle').html('<i class="btr bt-angles-left"></i><span>'+alll+caram.capitalize()+addd+'</span>');//callendar view
  	$('.close-spot').click();
  	setTimeout(() => map.flyTo(glb,14), 1000);
  } else {//subcategories
  	const isNative = Capacitor.isNative;
  	const ROOT = isNative ? 'https://hipster.io' : '';
	  const response = await fetch(`${ROOT}/json/menu.json`).then(response => response.json());
	  const cat = response.menu.find((o) => o.cat === caram);

	  if (cat) {
	    Object.keys(cat.subs).forEach(sub => {
	      const text = response.submenu[sub];
	      const root = isNative ? '/index.html' : '';
	    	$('.rightrail').append($(`<a data-category='${sub}' class='col'>`).html(
	      	`<img src="/fin/groups/${sub}.png" title="${text.name}" />`
	    	));
	    });
	    $('.rightrail').slideDown();
	  } else {
	    window.location.href = '/';
	  }

  	const title = response.submenu[param];
 	  $('.navtitle').toggle(title !== undefined);
  	if (title) $('.navtitle').html('<i class="btr bt-angles-left"></i><span>'+title.name+'</span>');
  }

  return response;
}

async function setTitle(response) {
  if (!response) response = await fetch(`${ROOT}/json/menu.json`).then(response => response.json());
  params = new URLSearchParams(window.location.search);
  param = params.get('g');
  caram = params.get('c');
  var temp=0;
  var addd='';
  var alll='';
  if(param==undefined || param=='null' || param==null){//categories with no group
  	const isNative = Capacitor.isNative;
  	const ROOT = isNative ? 'https://hipster.io' : '';
	  const response = await fetch(`${ROOT}/json/menu.json`).then(response => response.json());
	  const cat = response.menu.find((o) => o.cat === caram);

  	const title = response.menu[temp];
 	  $('.navtitle').toggle(title !== undefined);

  	if (title) $('.navtitle').html('<i class="btr bt-angles-left"></i><span>'+alll+caram.capitalize()+addd+'</span>');

  } else {//subcategories
  	const isNative = Capacitor.isNative;
  	const ROOT = isNative ? 'https://hipster.io' : '';
	  const response = await fetch(`${ROOT}/json/menu.json`).then(response => response.json());
	  const cat = response.menu.find((o) => o.cat === caram);

  	const title = response.submenu[param];
 	  $('.navtitle').toggle(title !== undefined);
  	if (title) $('.navtitle').html('<i class="btr bt-angles-left"></i><span>'+title.name+'</span>');
  }

  return response;
}


function getDescription(descr, menu) {
  return descr;
}

function getSVGMarker(color, fillColor, iconClass, spot) {
  const img = iconClass ? `<img class="marker-icon" src="/fin/groups/${iconClass}.png" />` : '';
  return `<div class="marker-container" id="${spot.place_id}">
            <svg width="32" height="44" viewBox="0 0 35 45" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 2.746c-8.284 0-15 6.853-15 15.307 0 .963.098 1.902.265 2.816a15.413 15.413 0 002.262 5.684l.134.193 12.295 17.785 12.439-17.863.056-.08a15.422 15.422 0 002.343-6.112c.123-.791.206-1.597.206-2.423 0-8.454-6.716-15.307-15-15.307" fill="${fillColor}" stroke="${color}" stroke-width="2px"></path></svg>
            ${img}
          </div>`;
}

function updateMarkers(spots, isOpen = false) {//go to line 40 of navigation
	var today = new Date();
	var dd = String(today.getDate()).padStart(2, '0');
	var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
	var yy = today.getYear();
	yy=yy-100;

	var todayDate = mm+dd+yy;
	var todayDay = today.getDay();
  markerGroup.clearLayers();
  $('.filters-content aside').remove();
  //$('.calendars-content article aside').remove();
  //$('.calendars-content address aside').remove();
  //console.log(spots);
  filterByHours(spots, isOpen).forEach((spot) => {
    const keys = Object.keys(spot.groups).filter((key) => spot.groups[key]);
    const group = keys.length ? keys[0] : 'arcade';
    const color = submenu[group].color;
    const icon = L.ExtraMarkers.icon({
      innerHTML: getSVGMarker(color, '#1b1a19', keys.length ? group : null, spot)
    });
    const isDuplicate = spots.filter((s) => s.name === spot.name).length > 1;
    const spotName = isDuplicate ? `${spot.name} - ${spot.neighborhood}` : spot.name;
    const marker = L.marker(spot.latlng, { icon, title: spot.name, riseOnHover: true })
      .on('click', window.onMarkerClick)
      .on('mouseover', (evt) => $(`.map-tooltip-${evt.target.id}`).css({ opacity: .9 }))
      .on('mouseout', (evt) => $(`.map-tooltip-${evt.target.id}`).css({ opacity: 0 }))
      .bindTooltip(`<div style="background-color:${color}">${spotName}</div>`, { interactive: true, permanent: true, direction: 'center', className: `map-tooltip map-tooltip-${spot.place_id}`, offset: L.point({ x: 0, y: -57 }), })
      .addTo(markerGroup);
    marker.getTooltip().setOpacity(0);
    marker.id = spot.place_id;

		$('.filters-content').append('<aside><span class="'+spot.place_id+'" data-id='+spot.place_id+'>'+spot.name+'</span><section><article>'+spot.neighborhood+'</article><div>'+spot.descr+'</div></section></aside>');

  });

	$(".filters-content aside").sort(asc_sort).appendTo('.filters-content');
	//$(".filters-content aside").first().css('margin-top','0px');
	$(".filters-content aside").last().css('margin-bottom','15px');


	$(".calendars-content article aside").sort(asc_sort).appendTo('.calendars-content article');
	$(".calendars-content address aside").sort(asc_sort).appendTo('.calendars-content address');

	$(".calendars-content article aside").last().css('margin-bottom','15px');
	$(".calendars-content address aside").last().css('margin-bottom','15px');

	$('.searchbox').remove();

  params = new URLSearchParams(window.location.search);
  param = params.get('g');
  caram = params.get('c');
  var temp=0;
  var addd='';
  var alll='';
	if(caram=='bar'){addd='s';alll='All ';}
	else if(caram=='breakfast'){addd=' Spots';}
	else if(caram=='restaurant'){addd='s';alll='All ';}
	else if(caram=='lunch'){addd=' Spots';}
	else if(caram=='cafe'){addd='s';alll='All ';}
	else if(caram=='brunch'){addd=' Spots';}
	else if(caram=='club'){addd='s';alll='All ';}
	else if(caram=='dinner'){addd=' Spots';}
	else if(caram=='store'){addd='s';alll='All ';}
	else if(caram=='latenight'){addd=' Spots';}
	else if(caram=='quiet'){addd=' Spots';}
	else if(caram=='divey'){addd=' Spots';}
	else if(caram=='casual'){addd=' Spots';}
	else if(caram=='lively'){addd=' Spots';}
	else if(caram=='intimate'){addd=' Spots';}

	if(param==undefined || param=='null' || param==null){
		$("<input class='searchbox' placeholder='Search "+alll+caram.capitalize()+addd+"'/>").insertBefore('.nav');
	} else{//temperal
		$("<input class='searchbox' placeholder='Search "+capitalize(param)+" Spots'/>").insertBefore('.nav');
		//$(".filters-content").prepend("<input class='searchbox' placeholder='Search "+title.name+"'/>");
	}
  return spots;
}

function adate(){
	var today1 = new Date();
	var dd1 = String(today1.getDate()).padStart(2, '0');
	var mm1 = String(today1.getMonth() + 1).padStart(2, '0');
	var yy1 = today1.getYear();
	yy1=yy1-100;

	var todayDate1 = mm1+dd1+yy1;
	var todayDay1 = today1.getDay();

	var da1=0;
	if(todayDay1==0){da1='sun';}
	else if(todayDay1==1){da1='mon';}
	else if(todayDay1==2){da1='tue';}
	else if(todayDay1==3){da1='wed';}
	else if(todayDay1==4){da1='thu';}
	else if(todayDay1==5){da1='fri';}
	else if(todayDay1==6){da1='sat';}
	var fullday1 = mm1+'/'+dd1;
	$('.todaydate').text(fullday1);
}

function calendarMarkers(){
	window.calendar = [];
	$('.calendars-content aside').remove();
	var today = new Date();
	var dd = String(today.getDate()).padStart(2, '0');
	var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
	var yy = today.getYear();
	yy=yy-100;

	var todayDate = mm+dd+yy;
	var todayDay = today.getDay();

	const groups = Object.values(_menu).filter((m) => caram.includes(m.cat));
  let spots = {};
  master_spots.forEach(spot => {
    groups.forEach(group => {
      Object.keys(group.subs).forEach(key => {
        if (spot.groups[key] && !spots[spot.place_id]) {
          spots[spot.place_id] = spot;
        }
      });
    });
  });
  param = params.get('g');
  spots = Object.values(spots);
  spots = param && param != 'null' ? spots.filter(spot => spot.groups && spot.groups[param]) : spots;
	const isOpen = $('#open').is(':checked');
	var da=0;
	if(todayDay==0){da='sun';}
	else if(todayDay==1){da='mon';}
	else if(todayDay==2){da='tue';}
	else if(todayDay==3){da='wed';}
	else if(todayDay==4){da='thu';}
	else if(todayDay==5){da='fri';}
	else if(todayDay==6){da='sat';}
	var counart=0;
	var counadr=0;
	var push=0;
	filterByHours(spots, false).forEach((spot) => {
	  //check1
	  push=0;
	  if( spot[da+todayDate]!==undefined){
	  	var temp=spot[da+todayDate];
	   	temp=temp.replace(/\,/g,'<br>');
		 	$('.calendars-content article').append('<aside><span class="'+spot.place_id+'" data-id='+spot.place_id+'>'+spot.name+'</span><em>'+spot.neighborhood+'</em><section>'+temp+'<br></section></aside>');
	  	counart++;
	  	window.calendar.push(spot);
	  	push=1;
	  }

	  //check2
	  if(todayDay==0 && spot.sun!==undefined){
	  	var temp=spot.sun;
	  	temp=temp.replace(/\,/g,'<br>');
		 	$('.calendars-content address').append('<aside><span class="'+spot.place_id+'" data-id='+spot.place_id+'>'+spot.name+'</span><em>'+spot.neighborhood+'</em><section>'+temp+'<br></section></aside>');
	  	if(push==0){window.calendar.push(spot);}
	  	counadr++;
	  } else if(todayDay==1 && spot.mon!==undefined){
	  	var temp=spot.mon;
	  	temp=temp.replace(/\,/g,'<br>');
		 	$('.calendars-content address').append('<aside><span class="'+spot.place_id+'" data-id='+spot.place_id+'>'+spot.name+'</span><em>'+spot.neighborhood+'</em><section>'+temp+'<br></section></aside>');
	  	if(push==0){window.calendar.push(spot);}
	  	counadr++;
	  } else if(todayDay==2 && spot.tue!==undefined){
	  	var temp=spot.tue;
	  	temp=temp.replace(/\,/g,'<br>');
		 	$('.calendars-content address').append('<aside><span class="'+spot.place_id+'" data-id='+spot.place_id+'>'+spot.name+'</span><em>'+spot.neighborhood+'</em><section>'+temp+'<br></section></aside>');
	  	if(push==0){window.calendar.push(spot);}
	  	counadr++;
	  } else if(todayDay==3 && spot.wed!==undefined){
	  	var temp=spot.wed;
	  	temp=temp.replace(/\,/g,'<br>');
		 	$('.calendars-content address').append('<aside><span class="'+spot.place_id+'" data-id='+spot.place_id+'>'+spot.name+'</span><em>'+spot.neighborhood+'</em><section>'+temp+'<br></section></aside>');
		 	if(push==0){window.calendar.push(spot);}
		 	counadr++;
	  } else if(todayDay==4 && spot.thu!==undefined){
	  	var temp=spot.thu;
	  	temp=temp.replace(/\,/g,'<br>');
		 	$('.calendars-content address').append('<aside><span class="'+spot.place_id+'" data-id='+spot.place_id+'>'+spot.name+'</span><em>'+spot.neighborhood+'</em><section>'+temp+'<br></section></aside>');
	  	if(push==0){window.calendar.push(spot);}
	  	counadr++;
	  } else if(todayDay==5 && spot.fri!==undefined){
	  	var temp=spot.fri;
	  	temp=temp.replace(/\,/g,'<br>');
		 	$('.calendars-content address').append('<aside><span class="'+spot.place_id+'" data-id='+spot.place_id+'>'+spot.name+'</span><em>'+spot.neighborhood+'</em><section>'+temp+'<br></section></aside>');
	  	if(push==0){window.calendar.push(spot);}
	  	counadr++;
	  } else if(todayDay==6 && spot.sat!==undefined){
	  	var temp=spot.sat;
	  	temp=temp.replace(/\,/g,'<br>');
		 	$('.calendars-content address').append('<aside><span class="'+spot.place_id+'" data-id='+spot.place_id+'>'+spot.name+'</span><em>'+spot.neighborhood+'</em><section>'+temp+'<br></section></aside>');
	  	if(push==0){window.calendar.push(spot);}
	  	counadr++;
	  }
	});
	if(counadr==0){
		//$('.calendars-content address header').css('display','none');
		var tempcat=$('.navtitle span').text();
		$('.calendars-content address header').html('No Deals or Events For<br>'+tempcat);
	} else{
		$('.calendars-content address header').css('display', 'block').text('Daily Deals & Events');
	}
	if(counart==0){
		$('.calendars-content article header').css('display','none');
		//$('.calendars-content article header').text('No Events or Concerts Today');
	} else{
		$('.calendars-content article header').css('display', 'block').text('Special Events & Concerts');
	}
	updateMarkers(window.calendar);
	$('.searchbox').hide();
}

const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

window.onMarkerClick = function (evt, goto = false) {
  const id = evt.target.id;
  const d = new Date();
  const spot = window.spots.find((spot) => spot.place_id === id);
  const descr = getDescription(spot.descr, Object.entries(window.submenu).map(([key, menu]) => ({ key, value: menu.aliases })));
  const isDuplicate = window.spots.filter((s) => s.name === spot.name).length > 1;
  const spotName = isDuplicate ? `${spot.name} - ${spot.neighborhood}` : spot.name;
  const bookmarkClass = Bookmark.bookmarks.filter(b => b.place_id === spot.place_id).length > 0 ? 'btr' : 'btl';

  const wantAsap=Bookmark.bookmarks.filter(b => b.place_id === spot.place_id).filter(b => b.spotStatus === 'wantAsap').length;
  const wantNorush=Bookmark.bookmarks.filter(b => b.place_id === spot.place_id).filter(b => b.spotStatus === 'wantNorush').length;
  const beenDontlike=Bookmark.bookmarks.filter(b => b.place_id === spot.place_id).filter(b => b.spotStatus === 'beenDontlike').length;
 	const beenAndlike=Bookmark.bookmarks.filter(b => b.place_id === spot.place_id).filter(b => b.spotStatus === 'beenAndlike').length;
 	var bookStatus='notInterested';
 	$('.heartModal .wantAsap').removeClass('onnit');
 	$('.heartModal .wantNorush').removeClass('onnit');
 	$('.heartModal .notInterested').removeClass('onnit').show();
 	$('.heartModal .beenDontlike').removeClass('onnit');
 	$('.heartModal .beenAndlike').removeClass('onnit');

 	if(wantAsap==1){bookStatus='wantAsap';$('.heartModal .wantAsap').addClass('onnit');} else
 	if(wantNorush==1){bookStatus='wantNorush';$('.heartModal .wantNorush').addClass('onnit');} else
 	if(beenDontlike==1){bookStatus='beenDontlike';$('.heartModal .beenDontlike').addClass('onnit');} else
 	if(beenAndlike==1){bookStatus='beenAndlike';$('.heartModal .beenAndlike').addClass('onnit');} else{$('.heartModal .notInterested').hide();}

 	console.log(bookStatus);
 	$('.desc.hidden').animate({"margin-left": `+=${$('.desc.hidden').outerWidth() + 8}`}).removeClass('hidden');
  $('.desc section').html(descr);
  $('.desc .desctitle').text(spotName);
  $('.desc .bt-heart').data('id', spot.place_id).removeClass('btl btr wantAsap wantNorush notInterested beenDontlike beenAndlike').addClass(bookmarkClass).addClass(bookStatus);
  $('.desc .descneigh, .desc .addraddr, .desc .desctime').hide();
  if (spot.neighborhood) $('.desc .descneigh').show().text(spot.neighborhood);
  if (spot.address) $('.desc .addraddr').show().text(spot.address.split(',')[0]).prop({ href: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${spot.name} ${spot.address}`)}`, target: '_blank' });
  if (spot.hours && spot.hours.weekday_text && spot.hours.weekday_text.length) {
    if (!spot.hours.weekday_text[0].includes('Sunday')) spot.hours.weekday_text.splice(0, 0, spot.hours.weekday_text.pop()); // move sunday to position 0
    $('.desc .desctime').show().html(`${formatTime(spot.hours.weekday_text[d.getDay()])} ${getHoursStatus(spot.hours.periods)}`);
  }

  $('.desc > *[class^="bt"]:not(.bt-heart)').hide();
  if (spot.phone) $('.bt-phone').show().prop('href', `tel:${spot.phone}`);
  if (spot.website) $('.bt-link').show().prop({ 'href': spot.website, target: '_blank' });
  if (spot.youtube) $('.bt-play-circle').show().data('id', spot.youtube);
	$('.bt-light-bulb').show();

  $('.time').data('id', spot.place_id);
  if (Video.isVideoPlaying) {
    if (spot.youtube) {
      Video.open($('.bt-play-circle').data('id'));
    } else {
      Video.close();
    }
  }
  if (goto) map.panTo(spot.latlng);
  $('.marker-container.active').removeClass('active');
  $(`#${id}`).addClass('active');
  if($('.bt-search').hasClass('active')){
  	$(`.${id}`).addClass('activity').get(0).scrollIntoView({ behavior: 'smooth', block: 'center' });
  } else{
  	$('.filters-content aside span').removeClass('activity');
  	$('.filters-content aside section article').removeClass('activity1');

  	$(`.filters-content .${id}`).addClass('activity').get(0).scrollIntoView({ behavior: 'smooth', block: 'center' });
  	$(`.filters-content .${id}`).next().find('article').addClass('activity1');

  	$('.filters-content aside').css('background','black');
  	$(`.filters-content .${id}`).parent().css('background','#1b3546');
  }
}

$(document).on('click', '.modal-gear .bt-times-circle', function() {
	$('.modal-gear').hide();
	$('.statusSelect').show();
});

$(document).on('click', '.close-auth', function() {
  location.reload();
  //setTimeout(function() {
    //$('.statusSelect').hide();
    //$('.searchbox').show();
    //$('.bt-ulist').click();
  //}, 1500);
});

$(document).on('click', '.bt-gear', async function() {
	var tempvar = await fetch(`https://hipster.io/api/user-settings/${Auth.uid}`).then(response => response.json());
  if(tempvar['userShow']==0){
  	$('.radionotshowing').click();
  } else{
  	$('.radioshowing').click();
  }
	$('.modal-gear').fadeIn(1000);
	$('.statusSelect').hide();
});

$('.filters-content').on('click', 'aside section', function() {
	$(this).parent().find('span').click();
});

$(document).on('click', '.filters-content', function() {
	$('.searchbox').show();
});

$(document).on('click', '.bookmark,.calendars', function() {
	$('.searchbox').hide();
});


$(document).on('click', '.calendars-content aside em', function() {
	$(this).prev().click();
});

$(document).on('click', '.calendars-content aside section', function() {
	$(this).prev().prev().click();
});

$(document).on('click', '.bt-light-bulb', function() {
	if (!Auth.isLoggedIn){
		$('.close-spot').click();
		return Auth.open();
	}
	window.spotId=$(this).parent().find('.bt-heart').data('id');
	window.spotName=$(this).parent().find('span').html();
	$('.lightbulbTitle').html(spotName);
	$('.lightbulb').fadeIn();
});

$(document).on('click', '.lightbulb .bt-times-circle', function() {
	$('.lightbulb').fadeOut();
});

$(document).on('click', '.lightbulb .lightbulbSubmit', function() {
	var spotTxt=$('.lightbulbTxt').val();
	var userId=Auth.uid;
	$.ajax({
    url: 'https://hipster.io/api/feedback',
    type: 'POST',
    data: {userId:userId,spotId:spotId,spotName:spotName,spotTxt:spotTxt},
    cache: false,
    success:function(data){
		  $('.lightbulbReceived').fadeIn();
    	$('.lightbulbTxt').val('');
			setTimeout(function() {
	    	$('.lightbulb').fadeOut();
			}, 1500);
    }
  });
});

$('.filters-content,.calendars-content').on('click', 'aside span', function() {

	if(window.innerWidth<700){
		setTimeout(function() {
	  	$('.bt-minus').click();
		}, 500);
	}
	$('.filters-content aside span').removeClass('activity');
	$('.filters-content aside section article').removeClass('activity1');

	$('.calendars-content aside span').removeClass('activity');
	$('.calendars-content aside section article').removeClass('activity');

	$('.calendars-content aside').css('background','black');
	$('.filters-content aside').css('background','black');
	$(this).parent().css('background','#1b3546');

	$(this).addClass('activity');
	$(this).next().find('article').addClass('activity1');

	const id = $(this).attr('data-id');
	let goto = true;
	const d = new Date();
	var tmptxt=$(this).text();
  const spot = window.spots.find((spot) => spot.name === tmptxt);
  const descr = getDescription(spot.descr, Object.entries(window.submenu).map(([key, menu]) => ({ key, value: menu.aliases })));
  const isDuplicate = window.spots.filter((s) => s.name === spot.name).length > 1;
  const spotName = isDuplicate ? `${spot.name} - ${spot.neighborhood}` : spot.name;
  const bookmarkClass = Bookmark.bookmarks.filter(b => b.place_id === spot.place_id).length > 0 ? 'btr' : 'btl';

  const wantAsap=Bookmark.bookmarks.filter(b => b.place_id === spot.place_id).filter(b => b.spotStatus === 'wantAsap').length;
  const wantNorush=Bookmark.bookmarks.filter(b => b.place_id === spot.place_id).filter(b => b.spotStatus === 'wantNorush').length;
  const beenDontlike=Bookmark.bookmarks.filter(b => b.place_id === spot.place_id).filter(b => b.spotStatus === 'beenDontlike').length;
 	const beenAndlike=Bookmark.bookmarks.filter(b => b.place_id === spot.place_id).filter(b => b.spotStatus === 'beenAndlike').length;
 	var bookStatus='notInterested';
 	$('.heartModal .wantAsap').removeClass('onnit');
 	$('.heartModal .wantNorush').removeClass('onnit');
 	$('.heartModal .notInterested').removeClass('onnit').show();
 	$('.heartModal .beenDontlike').removeClass('onnit');
 	$('.heartModal .beenAndlike').removeClass('onnit');
 	if(wantAsap==1){bookStatus='wantAsap';$('.heartModal .wantAsap').addClass('onnit');} else
 	if(wantNorush==1){bookStatus='wantNorush';$('.heartModal .wantNorush').addClass('onnit');} else
 	if(beenDontlike==1){bookStatus='beenDontlike';$('.heartModal .beenDontlike').addClass('onnit');} else
 	if(beenAndlike==1){bookStatus='beenAndlike';$('.heartModal .beenAndlike').addClass('onnit');} else{$('.heartModal .notInterested').hide();}

 	console.log(bookStatus);
  $('.desc.hidden').animate({"margin-left": `+=${$('.desc.hidden').outerWidth() + 8}`}).removeClass('hidden');
  $('.desc section').html(descr);
  $('.desc .desctitle').text(spotName);
  $('.desc .bt-heart').data('id', spot.place_id).removeClass('btl btr wantAsap wantNorush notInterested beenDontlike beenAndlike').addClass(bookmarkClass).addClass(bookStatus);
  $('.desc .descneigh, .desc .addraddr, .desc .desctime').hide();
  if (spot.neighborhood) $('.desc .descneigh').show().text(spot.neighborhood);
  if (spot.address) $('.desc .addraddr').show().text(spot.address.split(',')[0]+' (Get Directions)').prop({ href: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${spot.name} ${spot.address}`)}`, target: '_blank' });
  if (spot.hours && spot.hours.weekday_text && spot.hours.weekday_text.length) {
  	if (!spot.hours.weekday_text[0].includes('Sunday')) spot.hours.weekday_text.splice(0, 0, spot.hours.weekday_text.pop()); // move sunday to position 0
    $('.desc .desctime').show().html(`${formatTime(spot.hours.weekday_text[d.getDay()])} ${getHoursStatus(spot.hours.periods)}`);
  }

  $('.desc > *[class^="bt"]:not(.bt-heart)').hide();
  if (spot.phone) $('.bt-phone').show().prop('href', `tel:${spot.phone}`);
  if (spot.website) $('.bt-link').show().prop({ 'href': spot.website, target: '_blank' });
  if (spot.youtube) $('.bt-play-circle').show().data('id', spot.youtube);
  $('.bt-light-bulb').show();
  $('.time').data('id', spot.place_id);
  if (Video.isVideoPlaying) {
    if (spot.youtube) {
      Video.open($('.bt-play-circle').data('id'));
    } else {
      Video.close();
    }
  }
  if (goto) map.flyTo(spot.latlng,16);
  $('.marker-container').removeClass('active');

  $(`#${id}`).addClass('active');
	var seen = {};
	$('.filters-content aside').each(function() {
    var txt = $(this).text();
    if (seen[txt])
        $(this).remove();
    else
        seen[txt] = true;
	});
});

function formatTime(text) {
  return text.includes('Closed') ? text.replace('Closed', '') : text;
}

function filterByHours(spots, filterByHours) {
  return filterByHours ? spots.filter((spot) => spot.hours ? getHoursStatus(spot.hours.periods, true) : false) : spots;
}

function getHoursStatus(periods, onlyStatus = false) {
  let status = 0;
  const txt = ["<span class='closed'>Closed (See Hours)</span>", "<span class='open'>Open (See Hours)</span>"];
  const d = new Date();
  const d_op = new Date();
  const d_cl = new Date();
  const currentDay = d.getDay();

  periods = periods.filter((p) => p.close?.day === currentDay || p.open?.day === currentDay);
  if (!periods.length) return onlyStatus ? status : txt[status];

  const collection = [];
  //console.log(periods);
  periods.forEach((period) => {
    if (!period.open || !period.close) return;
    let distance = period.open.day - currentDay;
    d_op.setDate(d.getDate() + distance);
    d_op.setHours(period.open.time.substr(0, 2));
    d_op.setMinutes(period.open.time.substr(2, 2));
    //console.log(period);
    distance = period.close.day - currentDay;
    d_cl.setDate(d.getDate() + distance);
    d_cl.setHours(period.close.time.substr(0, 2));
    d_cl.setMinutes(period.close.time.substr(2, 2));
    collection.push(d > d_op && d < d_cl);
  });

  status = Number(collection.includes(true));
  return onlyStatus ? status : txt[status];
}

function checkForMobile() {
  const link = {
    'Android': 'https://play.google.com/store/apps/details?id=com.HipsterClicker',
    'iOS': 'https://apps.apple.com/us/app/hipster-io/id1534927560'
  }
  const hideBanner = JSON.parse(window.localStorage.getItem('mobileBanner'));
  const mobile = Utils.getMobileOperatingSystem();
  if (!mobile || hideBanner || isNative) return;
  setTimeout(() => $('.mobile-banner').fadeIn(), 10000);
  $('.close-banner').on('click', function() {
    $('.mobile-banner').fadeOut();
    window.localStorage.setItem('mobileBanner', JSON.stringify(true));
  });
  $('.view-app').prop('href', link[mobile]);
}

window.filterByGroup = function(groups, isOpen = false) {
  let spots = {};
  master_spots.forEach(spot => {
    groups.forEach(group => {
      Object.keys(group.subs).forEach(key => {
        if (spot.groups[key] && !spots[spot.place_id]) {
          spots[spot.place_id] = spot;
        }
      });
    });
  });
  param = params.get('g');
  spots = Object.values(spots);
  spots = param && param != 'null' ? spots.filter(spot => spot.groups && spot.groups[param]) : spots; updateMarkers(spots, isOpen);
}

function asc_sort(a, b){
  return ($(b).text()) < ($(a).text()) ? 1 : -1;
}

function dec_sort(a, b){
  return ($(b).text()) > ($(a).text()) ? 1 : -1;
}

window.revertSpots = function() {
	const groups = Object.values(_menu).filter((m) => caram.includes(m.cat));
	window.filterByGroup(groups);
}

history.pushState = ( f => function pushState(){
  var ret = f.apply(this, arguments);
  window.dispatchEvent(new Event('pushstate'));
  window.dispatchEvent(new Event('locationchange'));
  return ret;
})(history.pushState);

window.addEventListener('popstate',()=>{
  window.dispatchEvent(new Event('locationchange'))
});

window.setTitle = setTitle;
window.updateMarkers = updateMarkers;
